export default __webpack_public_path__ + "static/media/upload-good-example.dffc3e87.png";